import { Box, Typography } from '@mui/material'
import GppGoodIcon from '@mui/icons-material/GppGood';
import ErrorIcon from '@mui/icons-material/Error';

interface VerifiedWidgetProps {
    verified: boolean
}

const VerifiedWidget = ({verified}: VerifiedWidgetProps) => {
    return (
        <Box className='verfied-widget' sx= {{
            color: verified ? 'green' : 'red',
            display: 'flex',
            gap: '5px'
        }}>
            {verified ? <GppGoodIcon /> :  <ErrorIcon />}
            <Typography>
            {verified ? "Verified" :  "Verify now"}
            </Typography>
        </Box>
    )
}

export default VerifiedWidget